export const pageTypeMapping = {
    account: 'account',
    asset: 'asset',
    cat: 'category',
    class: 'class',
    checkout: 'checkout',
    confirm: 'confirm',
    course: 'course',
    document: 'document',
    home: 'home',
    learningBoard: 'learningBoard',
    meeting: 'meeting',
    member: 'member',
    membership: 'membership', // displays info on membership and will forward to checkout if /checkout appended
    memberships: 'memberships', // content page to market memberships
    'my-learnings': 'myLearnings',
    'my-meetings': 'myMeetings',
    program: 'program',
    search: 'search',
    microcast: 'microcast',
    instructor: 'instructor',
    'hub-dashboard': 'hubDashboard',
    'hub-documents': 'hubDocuments',
    'hub-learnings': 'hubLearnings',
    'hub-meetings': 'hubMeetings',
};
//# sourceMappingURL=PageType.js.map